import { User } from './../../interfaces/user';
import { ChatService } from './../../services/chat.service';
import { UserService } from './../../services/user.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import {
  Component,
  OnInit,
  ComponentFactoryResolver,
  Output,
  EventEmitter,
} from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-mensajes',
  templateUrl: './mensajes.component.html',
  styleUrls: ['./mensajes.component.css'],
})
export class MensajesComponent implements OnInit {
  mainUserId: string;
  searchValue = '';
  results: any = '';
  chatMessage = '';
  receiverId: string;
  chats = <any>[];
  chatMessages = [];
  currentDate: Date;
  otherUserId: any;
  chatId: string;
  chatUsers = [];
  chatUser: any;
  lastMessage: any;
  chatGroups = [];
  activeChats = [];
  chatLoader = false;
  notification = [];
  mainUserEmail: any;
  urlUid: any;
  firstName: any;
  lastName: any;
  classIds: any;
  // notifications: any;
  messageCount: number = 0;


  blockedClassIds=[
    "0MYFZ2lrZKZ69JjARsVB",
    "0MYFrkjV4l2THtX6CLGZ",
    "000LlElEx00000000",
    "000LlElEx00000001",
    "000LlElEx00000002",
    "000LlElEx00000003",
    "000LlElEx00000004",
    "000LlElEx00000005",
    "000LlElEx00000006",
    "000LlElEx00000007",
    "000LlElEx00000008",
    "000LlElEx00000009",
    "000LlElEx00000010",
    "000LlElEx00000011",
    "000LlElEx00000012",
    "000LlElEx00000013",
    "000LlElEx00000014",
    "000LlElEx00000015",
    "000LlElEx00000016",
    "000LlElEx00000017",
    "000LlElEx00000018"
  ]

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private chatService: ChatService,
    private notificationsService: NotificacionesService,
    private authenticationService: AuthenticationService
  ) {}

  getUserName(user: any): string {
    return user?.name || user?.firstName || '';
  }

  getUserLastName(user: any): string {
    return user?.last_name || user?.lastName || '';
  }

  getUserFullName(user: any): string {
    return `${this.getUserName(user)} ${this.getUserLastName(user)}`.trim();
  }

  private getClassIds(user: any): string[] {
    return user?.classes || [];
  }

  ngOnInit(): void {
    const userData: any = this.userService.getUserinfodata();

    if (userData === undefined) {
      this.authenticationService.getStatus().subscribe((status) => {
        this.mainUserId = status.uid;
        this.mainUserEmail = status.email;

        this.authenticationService
          .isUserAdmin(this.mainUserId)
          .subscribe((userdata) => {
            if (userdata[0]) {
              const userInfo: any = userdata[0];
              this.firstName = this.getUserName(userInfo);
              this.lastName = this.getUserLastName(userInfo);
              this.classIds = this.getClassIds(userInfo);

              this.notificationsService.getNotificacionesMensajes(this.mainUserId).subscribe(notifications => {
                this.messageCount = 0;
                if(notifications.length>0){
                  this.messageCount = notifications.length
                }
              })
            }
          });

        this.getChats();
      });
    } else {
      this.mainUserId = userData.payload.doc.data().uid;
      this.mainUserEmail = userData.payload.doc.data().email;
      this.firstName = this.getUserName(userData.payload.doc.data());
      this.lastName = this.getUserLastName(userData.payload.doc.data());
      this.classIds = this.getClassIds(userData.payload.doc.data());

      this.notificationsService.getNotificacionesMensajes(this.mainUserId).subscribe(notifications => {
        this.messageCount = 0;
        if(notifications.length>0){
          this.messageCount = notifications.length
        }
      })

      this.getChats();
    }

    this.chatService.getBorrarElChat().subscribe((deldata) => {
      const chatdeldata: any = deldata;
      this.deleteConversation(chatdeldata.mainUserId, chatdeldata.userId);
    });
  }

  search() {
    // if(this.classIds.includes("0MYFZ2lrZKZ69JjARsVB")){
    //   return
    // }
    // if(this.classIds.includes("0MYFrkjV4l2THtX6CLGZ")){
    //   return
    // }

    var classIds = [];
    (this.classIds || []).forEach(classId => {
      if(!this.blockedClassIds.includes(classId)){
        classIds.push(classId)
      }
    });


    this.userService.searchUsers(classIds).subscribe(searchdata => {
      this.results = searchdata;
    });
  }

  openchat(result) {
  this.receiverId = result.uid;
  const ids = [this.mainUserId, result.uid].sort();
  const chatId = ids.join('|');

  if (!this.chatUsers[result.uid]) {
    // NEW: create the chat document with the schema the backend expects.
    // The backend should use chatid as the document ID (verify with your
    // repository's createChat implementation — pass it explicitly if needed).
    this.chatService.createChat({
      user_ids: [this.mainUserId, result.uid],
      type: 'direct',
    }).catch((err) => {
      // 409 / already-exists is fine — the chat was created previously.
      if (err?.status !== 409) console.error('createChat error', err);
    });

    this.chatGroups[chatId] = [];
    this.chatUsers[result.uid] = result;
    this.activeChats[chatId] = { active: false };
  }
  this.results = '';
}

  getChats() {
    this.chatService.getChats(this.mainUserId).subscribe((chat) => {
      this.chats = chat;

      chat.forEach((chatData: any) => {
        const messageChatId = [
          chatData.members[0].uid,
          chatData.members[1].uid,
        ].sort();
        const themeChatId = messageChatId.join('|');

        this.chatGroups[themeChatId] = [];

        let receiverUser;

        if (chatData.members[1].uid !== this.mainUserId) {
          receiverUser = chatData.members[1].uid;
        } else {
          receiverUser = chatData.members[0].uid;
        }

        this.userService.getUserById(receiverUser).subscribe((user) => {
          if(user.length>0){
            this.chatUser = user[0].payload.doc.data();
            this.chatUsers[this.chatUser.uid] = [];
            this.chatUsers[this.chatUser.uid] = user[0].payload.doc.data();
              this.activeChats[themeChatId] = { active: false, nuevomessage: false };
          }
        });

        this.getLastMessage();
      });

      this.chatLoader = true;

      this.chatService.chatActual.subscribe((data) => {
        const thechatdata: any = data;
        this.urlUid = thechatdata;
        this.setChatStatus(this.activeChats[thechatdata]);
      });
    });
  }

  getLastMessage() {
    if (this.chatGroups) {
      // tslint:disable-next-line: forin
      for (let key in this.chatGroups) {
        this.chatService
          .getLastMessage(key, this.mainUserId)
          .subscribe((chat) => {
            this.chatGroups[key] = chat[0]?.payload.doc.data();

            if (
              !this.notification[chat[0]?.payload.doc.id] &&
              chat[0]?.payload.doc.data().receiver_id === this.mainUserId &&
              chat[0]?.payload.doc.data().seen === true
            ) {
              const audio = new Audio('assets/sounds/chatnotification.m4a');
              audio.play();
              this.notification[chat[0]?.payload.doc.id] = {};
              const chatId = [
                chat[0]?.payload.doc.data().receiver_id,
                chat[0]?.payload.doc.data().sender_id,
              ].sort();
              const chatIdJoin = chatId.join('|');
              const update = { nuevo: false };
              this.chatService
                .updatemessage(chatIdJoin, chat[0].payload.doc.id, update)
                .then();
              this.activeChats[chatIdJoin] = { nuevomessage: true };
            }
          });
      }
    }
  }

  deleteConversation(mainUserId, receiveruid) {
    const members = {
      members: [
        { uid: mainUserId, join: false },
        { uid: receiveruid, join: true },
      ],
    };
    const chatId = [mainUserId, receiveruid].sort();
    const preChatId = chatId.join('|');

    this.chatService.deleteconversation(preChatId, members, receiveruid);
    this.router.navigate(['dashboard', 'mensajes']);

    delete this.chatGroups[preChatId];
    delete this.activeChats[preChatId];
    delete this.chatUsers[receiveruid];
  }

  setChatStatus(chat) {
    const fruit_keys = Object.keys(this.activeChats);
    fruit_keys.forEach((thechat) => {
      if (this.activeChats[thechat]) {
        this.activeChats[thechat].active = false;
      }
    });

    if (!chat) {
      chat = this.activeChats[this.urlUid] = {
        active: false,
        nuevomessage: false,
      };
    }

    chat.nuevomessage = false;
    chat.active = true;
  }
}
